import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

/**
 * A single 6-digit TOTP code field, shared by the enrolment and step-up flows.
 * Numeric-only, autocomplete `one-time-code` so password managers/keyboards
 * offer the authenticator code. UX text is Dutch.
 */
export function MfaCodeInput({
  id,
  value,
  onChange,
  disabled,
  autoFocus,
}: {
  id: string
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  autoFocus?: boolean
}) {
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id}>6-cijferige code</Label>
      <Input
        id={id}
        inputMode="numeric"
        autoComplete="one-time-code"
        pattern="[0-9]*"
        maxLength={6}
        placeholder="123456"
        required
        autoFocus={autoFocus}
        disabled={disabled}
        value={value}
        // Keep only digits and cap at 6 so a paste with spaces/dashes still works.
        onChange={(event) => onChange(event.target.value.replace(/\D/g, '').slice(0, 6))}
        className="text-center font-mono text-lg tracking-[0.4em]"
      />
    </div>
  )
}
